import SoukBargainGame from './SoukBargainGame';
import config from './config.json';

export { config };
export default SoukBargainGame;
